import React, { memo, useMemo } from "react";
import styled from "styled-components";

import { ChatMessage as ChatMessageServices } from "../../../../../../../../../services";
import { useAppContext } from "../../../../../../../../../context";
import { StyledColumn } from "../../../../../../../../common";

import { Title, Message } from "./components";

const GroupMessage = styled.div`
	border-radius: 8px 8px 8px 4px;
	overflow: hidden;
`;

const Messages: React.FC<Messages.Props> = ({ data, onClickFindParent }) => {
	const { isCurrentUser, createdAt, title, content, parent } = data;
	const { dateFns } = useAppContext();

	const getTimeCreated = useMemo(
		() => dateFns.toClockFaceTime(createdAt),
		[createdAt, dateFns],
	);

	const reference = useMemo(() => parent ?? null, [parent]);

	const listContent = useMemo(
		() => [reference, content].filter(Boolean),
		[content, reference],
	);
	return (
		<StyledColumn gap="6px">
			<Title
				data={{
					isCurrentUser,
					title,
					time: getTimeCreated,
				}}
			/>
			<GroupMessage>
				{listContent?.map((message, i) => (
					<Message
						key={i}
						data={{
							message: message || "",
							isCurrentUser,
						}}
						onClickFindParent={onClickFindParent}
					/>
				))}
			</GroupMessage>
		</StyledColumn>
	);
};

declare namespace Messages {
	interface Props {
		data: {
			isCurrentUser: boolean;
			createdAt: string;
			title?: string;
			content?: string;
			parent?: ChatMessageServices.OutputGrouped.ChatMessage;
		};
		onClickFindParent?: (parentId: number) => void;
	}
}

export default memo(Messages);
